import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import { ConstantsService } from '../constants/constants.service';
declare var $:any;

export const pashuposhanInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  
  const router = inject(Router);
  const constants = inject(ConstantsService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        constants.errorMsg(constants.MESSAGES['UNAUTHORIZED']);
        router.navigate(['login']); 
      } else if(error.status === 403){
        constants.errorMsg(constants.MESSAGES['FORBIDDEN']);
        router.navigate(['dashboard']);
      } else {
        if(error.error && error.error.message){
          if (error.error.message.includes('साप्ताहिक नोंदणी') && router.url.includes('new-application')) {
            // Suppressed here because the component shows a custom popup
          } else if (error.error.message.includes('योग्य रजिस्ट्रेशन क्रमांक टाकावा') && router.url.includes('new-application')) {
            // Suppressed here because the component shows a custom popup
          } else if (error.error.message.includes('Has Already Submitted The Application') && router.url.includes('new-application')) {
            // Suppressed here because the component shows a custom popup
          } else {
            constants.errorMsg(error.error.message);
          }
        }else{
          constants.errorMsg(constants.MESSAGES['ERROR']);
        }
      }
      // You can customize error handling for other status codes as needed

      return throwError(() => error);
    })
  );
};
